import * as React from "react";
import styles from "./Drawer.module.scss";
import {FC} from "react";
import {IButtonOptions} from "devextreme-react/button";
import {Button} from "devextreme-react";

type DrawerProps = {
    title: string;
    description?: React.ReactNode;
    onClose: () => void;
    saveAction?: IButtonOptions;
    closeAction?: IButtonOptions;
    deleteAction?: IButtonOptions;
    otherActions?: JSX.Element;
    titleAction?: JSX.Element;
}
export const Drawer: FC<DrawerProps> = ({onClose, title,  description, children, saveAction, titleAction, deleteAction, otherActions, closeAction}) => {
    const _onClose = () => {
        onClose();
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <div className={styles.close}>
                    <i onClick={_onClose} className={`dx-icon-back ${styles.icon}`}></i>
                </div>
                {title}
                {description}
                <div className={styles.titleAction}>{titleAction}</div>

            </div>
            <div className={styles.body}>
                {children}
            </div>
            <div className={styles.footer}>
                {closeAction &&
                    <Button
                        {...closeAction}
                    />
                }
                <div className={styles.moreActions}>
                    {otherActions}
                </div>
                {saveAction &&
                    <Button
                        type="default"
                        className={styles.save}
                        {...saveAction}
                    />
                }
                {
                    deleteAction &&
                    <Button
                        stylingMode="outlined"
                        type="danger"
                        className={styles.delete}
                        {...deleteAction}
                    />
                }
            </div>
        </div>
    );
};